import EPublicRoutes from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import {
  Button,
  Divider,
  Flex,
  Group,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { useBasketStore } from "@modules/order/stores/Basket.store";
import { AppNotification } from "@notifications/Notification";
import useBuyModalStore from "@store/buyModal.store";

const BuyModal: React.FC = () => {
  const { isOpened, account, close, onBuy } = useBuyModalStore();
  const { t } = useAppTranslation("components.modals.buy");
  const { t: productT } = useAppTranslation();
  const { navigate } = useAppNavigate();
  const basket = useBasketStore();

  const addToBasket = () => {
    if (!account) return;

    onBuy?.(false);
    basket.addBasketAccount(account);
  };

  const handleBuyNow = () => {
    addToBasket();
    onBuy?.(true);
    close();
    navigate(EPublicRoutes.BASKET);
  };

  const getLine = (label: string, value: string) => (
    <Group className="w-full text-primary-dark-text" justify="space-between">
      <span>{label}</span>
      <span className="text-primary-light-text">{value}</span>
    </Group>
  );

  return (
    <>
      <Modal
        centered
        classNames={{
          content: "bg-primary-default select-none rounded-lg",
          header: "bg-primary-default shadow-lg",
        }}
        closeButtonProps={{ className: "default-icon" }}
        opened={isOpened}
        title={
          <Text className="font-secret-black text-primary-white ">
            {productT(`${account?.i18nKey}.basket.modalTitle`, {
              prefix: account?.prefix,
            }).toUpperCase()}
          </Text>
        }
        onClose={close}
      >
        <Stack className="font-inter" pt={20}>
          {getLine(t("tag"), productT(`${account?.i18nKey}.name`))}
          {getLine(t("pricePerAccount"), `${account?.price}€`)}
          {getLine(t("region"), account?.region.toUpperCase() ?? "")}
          {getLine(t("warranty"), t("warrantyValue"))}

          <Divider />

          {getLine(t("total"), `${account?.price}€`)}
          <Flex className="w-full" gap={20} justify="center">
            <Button
              className="default-icon hover-scale flex-1 text-primary-light-text hover:text-primary-light-text"
              onClick={() => {
                addToBasket();
                AppNotification.default({
                  title: t("notifications.successTitle"),
                  message: t("notifications.successMessage"),
                });

                close();
              }}
            >
              {t("addToBasket")}
            </Button>
            <Button
              className="gradient-blue-purple hover-scale flex-1"
              variant="gradient"
              onClick={handleBuyNow}
            >
              {t("buyNow")}
            </Button>
          </Flex>
        </Stack>
      </Modal>
    </>
  );
};

export default BuyModal;
